import authHelper from '@/helpers/auth';
import apiAuth from '@/api/auth';

const defaultState = () => ({
	isAuth: authHelper.loggedIn(),
	isAttempting: false,
	responseError: {},
	userData: authHelper.getUserData(),
});

const state = defaultState();

const getters = {
	isAuth(state) {
		return state.isAuth;
	},
};

const mutations = {
	attempting(state) {
		state.isAttempting = true;
		state.responseError.show = false;
	},
	attempted(state) {
		state.isAttempting = false;
	},
	failed(state, data) {
		state.responseError = data
	},
	setProfileData(state, data) {
		authHelper.setProfileData(data);
		state.userData = authHelper.getUserData();
		state.isAuth = true;
		state.responseError.show = false;
	},
	setImageData(state, data) {
		authHelper.setImageData(data);
		state.userData = authHelper.getUserData();
		state.isAuth = true;
		state.responseError.show = false;
	},
	updateImage(state, image) {
		state.userData.image_url = image
		authHelper.setData(state.userData);
		state.userData = authHelper.getUserData();
	},
	success(state, authData) {
		state.responseError = {}
		authHelper.setData(authData);
		state.userData = authHelper.getUserData();
		state.isAuth = true;
		state.responseError.show = false;
	},
	successSSO(state, authData) {
		localStorage.removeItem('mlmcore-vo-auth-data')
		authHelper.clearData();
		authHelper.setData(authData);
		state.userData = authHelper.getUserData();
		state.isAuth = true;
		state.responseError.show = false;
	},
	removeAlert(state, id) {
		const index = Array.from(state.alerts).findIndex(it => it.id === id);

		if (index !== -1) {
			state.alerts.splice(index, 1);
		}
	},
	clearData(state) {
		state.isAuth = false;
		authHelper.clearData();
	},
	reset(state) {
		Object.assign(state, defaultState());
	},
};

const actions = {
	login({ commit, dispatch }, { username, phonenumber, password }) {
		return new Promise((resolve, reject) => {
			commit('attempting');
			apiAuth.login(username, phonenumber, password).then(({ data }) => {
				if ( data.status == '200' ) {
					commit('success', data.results.data);
					resolve(data.results.data);
				} else {
					dispatch('errorHandler', data);
					reject(true);
				}
				
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data);
			}).then(() => {
				commit('attempted');
			});
		});
	},
	loginsso({ commit }, data) {
		return new Promise((resolve) => {
			commit('successSSO', data);
			resolve()
		});
	},
	register({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			commit('attempting');
			apiAuth.register(params).then(() => {
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			}).then(() => {
				commit('attempted');
			});
		});
	},
	forgetPassword({ commit, dispatch }, { mobilephone, email }) {
		return new Promise((resolve, reject) => {
			commit('attempting');
			apiAuth.forgetPassword(mobilephone, email).then(({ data }) => {
				commit('makeAlert', { code: 'success', type: 'success', message: data.message, show: true }, { root: true });
				resolve(true);
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data);
				reject(data)
			}).then(() => {
				commit('attempted');
			});
		});
	},
	confirmNewPassword({ commit, dispatch }, { token, password, repassword }) {
		return new Promise((resolve, reject) => {
			commit('attempting');
			apiAuth.confirmNewPassword(token, password, repassword).then(({ data }) => {
				commit('makeAlert', { code: 'success', type: 'success', message: data.message, show: true }, { root: true });
				resolve(true);
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data);
				reject(data)
			}).then(() => {
				commit('attempted');
			});
		});
	},
	verifyToken({ commit, dispatch }, { token }) {
		return new Promise((resolve, reject) => {
			commit('attempting');
			apiAuth.verifyToken(token).then(() => {
				resolve(true);
				commit('attempted');
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data);
				reject(data)
			})
		});
	},
	logout({ commit }) {
		commit('clearData');

		return Promise.resolve(true);
	},
	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;
					
				case 'ERROR':
					commit('failed', response)
					// commit('setSnackbar', {
					// 	show: true,
					// 	color: 'red darken-2',
					// 	text: response.message
					// }, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;
			}
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};